import React from 'react';
import PropTypes from 'prop-types';
import '../styles/Login.css';

/**
 * Login component for handling user authentication
 * 
 * @param {Object} props - Component properties
 * @param {Function} props.onLogin - Login handler function
 * @returns {JSX.Element} Login component
 */
const Login = ({ onLogin }) => {
  return (
    <div className="login-container">
      <div className="login-prompt">
        <h2>Welcome to <b>CyberProof Dashboard</b></h2>
        <p>Please login to access the application.</p>
        <button className="login-button" onClick={onLogin}>Login</button>
      </div>
    </div>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired
};

export default Login;
